
import { t } from '@/plugins/i18n'
export const tableColumns = [
  {
    label: t('商品名称'),
    width: 136,
    name: 'title',
    trWidth: 212,
    confirmWidth: 250
  },
  {
    label: t('客户SKU'),
    width: 120,
    name: 'customSku',
    confirmWidth: 120
  },
  {
    label: t('商品属性'),
    width: 120,
    name: 'sku',
    confirmWidth: 120
  },
  {
    label: t('数量'),
    width: 120,
    name: 'amount',
    confirmWidth: 120
  },
  {
    label: t('计价规格'),
    width: 100,
    name: 'priceType',
    confirmWidth: 100
  },
  {
    label: t('全包价(JPY)'),
    width: 80,
    name: 'allPrice',
    confirmWidth: 80
  },
  {
    label: t('小计(JPY)'),
    width: 80,
    name: 'totalPrice',
    confirmWidth: 80
  },
  {
    label: t('商品附加项'),
    width: 120,
    name: 'adt',
    confirmWidth: 120
  }
]
